import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { PulsaraConstants } from '../store/pulsara.constants'
import { setPulsaraAttachments } from '../store/pulsara.actions'
import { IPulsaraAttachmentImage, IPulsaraAttachmentStored } from '../store/pulsara.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getPulsaraAttachmentsForDisplay() {
  const pcrId: string = yield select(getPcrIdSelector)
  if (!pcrId) return

  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    if (pcrDoc.pulsara?.pulsaraAttachments?.length) {
      const savedAttachments: IPulsaraAttachmentImage[] = pcrDoc.pulsara.pulsaraAttachments.map(
        (att: IPulsaraAttachmentStored) => ({
          ...att,
          blobData: '',
          isUnavailable: null,
        })
      )
      yield put(setPulsaraAttachments(savedAttachments))
    } else {
      yield put(setPulsaraAttachments([]))
    }
  } catch (e) {
    yield put(throwPcrException(`getPulsaraAttachmentsForDisplay() error: ${e}`))
  }
}

export function* getPulsaraAttachmentsSaga() {
  yield takeLatest([PulsaraConstants.GET_PULSARA_ATTACHMENTS], performWithMutexHOG, getPulsaraAttachmentsForDisplay)
}
